import ResourceSvc from '@/services/resource.svc.js';
const request = new ResourceSvc();
import { EventBus } from '@/services/Event.js';
import { Checkbox, Popover } from 'element-ui';

export default {
    name: 'Payment',
    props: {
        main_race_id: [Number, String],
        name: String,
        type: String,
        start: [String, Date],
        location: [String],
        same_day_races: Array,
        using_ti_entry: String,
        age_group: String,
        same_day_races: Array,
        current_fee: Number
    },
    components: {
        [Popover.name]: Popover,
        [Checkbox.name]: Checkbox,
    },
    computed: {
        id() {
            return this.$route.params.id;
        },
        total_price() {
            var price = this.current_fee;
            if (this.same_day_races && this.same_day_races.length) {
                price = 0;
                this.same_day_races.forEach(race => {
                    price += race.sanctioningPrice;
                });
            }

            return price;
        },
        is_finished_all_registrations() {
            return !this.same_day_races || !this.same_day_races.length
                || !this.same_day_races.filter(x => { return !x.isFinishedRegistration }).length
        }
    },
    data() {
        return {
            isDeleteRequest: false,
            deleteRaceId: null,
            isProcessing: false,
            isAcceptedTermsAndConditions: false
        };
    },
    methods: {
        console(message) {
            if (console && console.log) {
                if (message) {
                    console.log(message);
                }
                else {
                    var date = new Date();
                    console.log("-------> " + date.getMinutes() + ":" + date.getSeconds());
                }
            }
        },
        add_same_day_race() {
            if (this.id != this.main_race_id) {
                this.$router.push(`/dashboard/my-race/${this.main_race_id}`);
            }

            setTimeout(() => {
                this.$router.push(`/dashboard/my-race/0?sdrId=${this.main_race_id}`);
            }, 0);

        },
        change_race(id) {
            this.$router.push(`/dashboard/my-race/${id}`);
        },
        remove_race(id) {
            self = this;
            if (id == self.main_race_id) {
                self.
                    return;
            }
            self.isProcessing = true;
            request.deleteRemoveRace(id)
                .then(response => {
                    self.isProcessing = false;
                    self.deleteRaceId = null;
                    self.isDeleteRequest = null;

                    if (!response.body.isSuccess) {
                        self.$showError(response.body.message);
                    }
                    EventBus.$emit('race-layout-reload')
                },
                    error => {
                        self.isProcessing = false;
                        self.$showError();
                    });
        },

        confirmOrPayForRace() {
            var self = this;
            var id = self.main_race_id ? self.main_race_id : self.id;

            request.postPrepareSanctioningFeeTempData(id)
                .then(response => {
                    if (response && response.body && response.body.isSuccess) {
                        self.$showSuccess();
                        if (response.body.redirectUrl) {
                            setTimeout(() => {
                                self.$router.push({ path: response.body.redirectUrl + id });
                            }, 1000)
                        } else {
                            setTimeout(() => {
                                EventBus.$emit('race-layout-reload');
                            }, 1000)
                        }
                    }
                    else {
                        self.$showError(response && response.body && response.body.message ? response.body.message : null);
                    }
                })
        }
    },
    mounted() {
    },
};



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/races/view-race/payment/payment.js